import { render, staticRenderFns } from "./Proveedor.vue?vue&type=template&id=1e0a1d8c&lang=true"
import script from "./Proveedor.vue?vue&type=script&lang=js"
export * from "./Proveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports